import { render, staticRenderFns } from "./AlertContainer.vue?vue&type=template&id=25234b1a&scoped=true&"
import script from "./AlertContainer.vue?vue&type=script&lang=js&"
export * from "./AlertContainer.vue?vue&type=script&lang=js&"
import style0 from "./AlertContainer.vue?vue&type=style&index=0&id=25234b1a&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25234b1a",
  null
  
)

export default component.exports